// // src/pages/auth/CourtOwnerLogin.jsx
// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import bgimage from "../../assets/backgroundlogin.png";
// import { courtOwnerApi } from "../../api/courtOwnerApi";

// const BACKEND_URL = "https://api.getfitindia.in/api/courtowner/auth";

// export default function CourtOwnerLogin() {
//   const [mode, setMode] = useState("login"); // "login" | "register"

//   const [mobile, setMobile] = useState("91");
//   const [otp, setOtp] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Registration form state
//   const [regForm, setRegForm] = useState({
//     name: "",
//      email: "",
//     businessName: "",
//     address: "",
//     additionalMobiles: "",
//   });

//   // UI controls
//   const [cooldown, setCooldown] = useState(0);
//   const [lockMsg, setLockMsg] = useState("");
//   const [isBlocked, setIsBlocked] = useState(false);
//   const cooldownTimerRef = useRef(null);
//   const navigate = useNavigate();

//   /* ===================== Utils ===================== */

//   const normalizeMobile = (value) => {
//     let val = value.replace(/\D/g, "");
//     if (!val.startsWith("91")) val = "91" + val.replace(/^91/, "");
//     return val.slice(0, 12);
//   };

//   const isValidMobile = (m) => /^91\d{10}$/.test(m);

//   const clearCooldown = () => {
//     if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
//     setCooldown(0);
//   };

//   const startCooldown = (seconds) => {
//     setCooldown(seconds);
//     clearCooldown();
//     cooldownTimerRef.current = setInterval(() => {
//       setCooldown((c) => {
//         if (c <= 1) {
//           clearCooldown();
//           return 0;
//         }
//         return c - 1;
//       });
//     }, 1000);
//   };

//   // Cleanup timer
//   useEffect(() => {
//     return () => {
//       if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
//     };
//   }, []);




//   const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

//   /* ===================== Handlers: LOGIN (OTP) ===================== */

//   const handleSendOtp = async () => {
//     if (!isValidMobile(mobile)) return alert("Enter 91 + 10 digit mobile.");
//     if (isBlocked) return;

//     setLoading(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/otp/request`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ mobile }),
//       });
//       const data = await res.json();

//       if (res.ok) {
//         setOtp("");
//         setOtpSent(true);
//         setLockMsg("");
//         setIsBlocked(false);
//         startCooldown(60);
//       } else if (res.status === 423) {
//         // 🔒 Server says locked => show message & block UI
//         setIsBlocked(true);
//         setLockMsg(data.error || "Too many attempts. Try again later.");
//         setOtpSent(false);
//         clearCooldown();
//       } else if (res.status === 404) {
//         alert("Court Owner not registered. Please register first.");
//       } else {
//         alert(data.error || "Failed to send OTP");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     if (!/^\d{6}$/.test(otp)) return alert("Enter 6 digit OTP");
//     if (isBlocked) return;

//     setLoading(true);
//     try {
//       const res = await fetch(`${BACKEND_URL}/otp/verify`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ mobile, otp }),
//       });
//       const data = await res.json();

//       if (res.ok) {
//         localStorage.setItem("courtOwnerToken", data.token);
//         localStorage.setItem("role", "court_owner");
//         alert("Login successful!");
//         navigate("/courtowner/dashboard");
//       } else if (res.status === 423) {
//         setIsBlocked(true);
//         setLockMsg(data.error || "Account locked. Try again later.");
//       } else {
//         alert(data.error || "OTP verification failed");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const swapNumber = () => {
//     setOtpSent(false);
//     setOtp("");
//     setIsBlocked(false);
//     setLockMsg("");
//     clearCooldown();
//   };

//   /* ===================== Handler: REGISTER ===================== */

//  const handleRegister = async () => {
//   if (!isValidMobile(mobile)) {
//     return alert("Enter 91 + 10 digit mobile.");
//   }
//   if (!regForm.name.trim()) {
//     return alert("Name is required");
//   }
//   if (!regForm.businessName.trim()) {
//     return alert("Business Name is required");
//   }
//   if (!regForm.email.trim()) {
//     return alert("Email is required");
//   }
//   if (!isValidEmail(regForm.email.trim())) {
//     return alert("Enter a valid email address.");
//   }

//   const payload = {
//     name: regForm.name.trim(),
//     email: regForm.email.trim().toLowerCase(),
//     businessName: regForm.businessName.trim(),
//     address: regForm.address.trim(),
//     mobile,
//   };

//   setLoading(true);
//   try {
//     const data = await courtOwnerApi.register(payload); // /api/courtowner/auth/register

//     if (data.success) {
//       alert("Registered successfully. Please login with OTP.");
//       setRegForm({
//         name: "",
//         email: "",
//         businessName: "",
//         address: "",
//         additionalMobiles: "",
//       });
//       setMode("login");
//     } else {
//       alert(data.error || "Registration failed");
//     }
//   } finally {
//     setLoading(false);
//   }
// };

//   /* ===================== Render ===================== */

//   const isLoginMode = mode === "login";

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center p-4 bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bgimage})` }}
//     >
//       <div className="absolute inset-0 bg-black opacity-60" />
//       <div className="relative bg-white p-8 rounded-xl shadow-2xl w-full max-w-md transition-all duration-300">
//         <h2 className="text-3xl font-extrabold text-center mb-6 text-gray-800">
//           Court Owner {isLoginMode ? "Login" : "Register"}
//         </h2>

//         {/* Tabs */}
//         <div className="flex mb-6 border rounded-lg overflow-hidden">
//           <button
//             className={`flex-1 py-2 text-sm font-semibold ${
//               isLoginMode
//                 ? "bg-indigo-600 text-white"
//                 : "bg-gray-100 text-gray-700"
//             }`}
//             onClick={() => {
//               setMode("login");
//               setOtpSent(false);
//               setOtp("");
//               setIsBlocked(false);
//               setLockMsg("");
//               clearCooldown();
//             }}
//           >
//             Login with OTP
//           </button>
//           <button
//             className={`flex-1 py-2 text-sm font-semibold ${
//               !isLoginMode
//                 ? "bg-indigo-600 text-white"
//                 : "bg-gray-100 text-gray-700"
//             }`}
//             onClick={() => {
//               setMode("register");
//               setOtpSent(false);
//               setOtp("");
//               setIsBlocked(false);
//               setLockMsg("");
//               clearCooldown();
//             }}
//           >
//             Register
//           </button>
//         </div>

//         {/* Common Mobile Field */}
//         <label className="block text-sm font-medium mb-1">
//           Mobile Number (91XXXXXXXXXX)
//         </label>
//         <input
//           type="text"
//           value={mobile}
//           onChange={(e) => setMobile(normalizeMobile(e.target.value))}
//           disabled={isLoginMode && otpSent}
//           className="w-full px-5 py-3 border rounded-lg mb-2"
//         />

//         {/* ===== LOGIN MODE ===== */}
//         {isLoginMode && (
//           <>
//             {lockMsg ? (
//               <p className="text-red-600 text-sm mb-2">{lockMsg}</p>
//             ) : !otpSent ? (
//               <p
//                 className={`text-sm mb-2 ${
//                   isValidMobile(mobile) ? "text-green-600" : "text-gray-500"
//                 }`}
//               >
//                 {isValidMobile(mobile)
//                   ? "Mobile looks good."
//                   : "Enter 91 + 10 digits."}
//               </p>
//             ) : null}

//             {otpSent && (
//               <>
//                 <label className="block text-sm font-medium mb-1 mt-2">
//                   Enter 6-digit OTP
//                 </label>
//                 <input
//                   type="text"
//                   value={otp}
//                   onChange={(e) =>
//                     setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
//                   }
//                   disabled={isBlocked}
//                   className="w-full px-5 py-3 border rounded-lg mb-2"
//                 />
//               </>
//             )}

//             <button
//               onClick={!otpSent ? handleSendOtp : handleVerifyOtp}
//               disabled={
//                 loading ||
//                 isBlocked ||
//                 (!otpSent && (cooldown > 0 || !isValidMobile(mobile))) ||
//                 (otpSent && otp.length !== 6)
//               }
//               className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold disabled:bg-gray-400 disabled:cursor-not-allowed"
//             >
//               {loading
//                 ? "Processing..."
//                 : isBlocked
//                 ? "Locked"
//                 : !otpSent
//                 ? cooldown > 0
//                   ? `Send OTP (${cooldown}s)`
//                   : "Send OTP"
//                 : "Verify OTP"}
//             </button>

//             {otpSent && (
//               <div className="mt-4 flex justify-between text-sm">
//                 <button className="underline" onClick={swapNumber}>
//                   Change number
//                 </button>
//                 <button
//                   disabled={cooldown > 0 || isBlocked}
//                   onClick={handleSendOtp}
//                   className={`underline ${
//                     cooldown > 0 || isBlocked
//                       ? "text-gray-400"
//                       : "text-indigo-600"
//                   }`}
//                 >
//                   {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend OTP"}
//                 </button>
//               </div>
//             )}
//           </>
//         )}

//         {/* ===== REGISTER MODE ===== */}
//         {!isLoginMode && (
//           <>
//             <p className="text-sm text-gray-600 mb-3">
//               Enter your details to register as a Court Owner. After
//               registration, you can login using OTP on this same mobile number.
//             </p>

//             <label className="block text-sm font-medium mb-1">Name</label>
//             <input
//               type="text"
//               value={regForm.name}
//               onChange={(e) =>
//                 setRegForm((f) => ({ ...f, name: e.target.value }))
//               }
//               className="w-full px-5 py-3 border rounded-lg mb-3"
//             />
// {/* 👇 NEW: Email */}
//     <label className="block text-sm font-medium mb-1">Email</label>
//     <input
//       type="email"
//       value={regForm.email}
//       onChange={(e) =>
//         setRegForm((f) => ({ ...f, email: e.target.value }))
//       }
//       className="w-full px-5 py-3 border rounded-lg mb-3"
//     />

//             <label className="block text-sm font-medium mb-1">
//               Business Name
//             </label>
//             <input
//               type="text"
//               value={regForm.businessName}
//               onChange={(e) =>
//                 setRegForm((f) => ({ ...f, businessName: e.target.value }))
//               }
//               className="w-full px-5 py-3 border rounded-lg mb-3"
//             />

//             <label className="block text-sm font-medium mb-1">Address</label>
//             <textarea
//               rows={3}
//               value={regForm.address}
//               onChange={(e) =>
//                 setRegForm((f) => ({ ...f, address: e.target.value }))
//               }
//               className="w-full px-5 py-3 border rounded-lg mb-3 resize-none"
//             />

//             <button
//               onClick={handleRegister}
//               disabled={loading}
//               className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold disabled:bg-gray-400 disabled:cursor-not-allowed"
//             >
//               {loading ? "Registering..." : "Register"}
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }




// src/pages/auth/CourtOwnerLogin.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import bgimage from "../../assets/backgroundlogin.png";
import { courtOwnerApi } from "../../api/courtOwnerApi";

const BACKEND_URL = "https://api.getfitindia.in/api/courtowner/auth";

export default function CourtOwnerLogin() {
  const [mode, setMode] = useState("login"); // "login" | "register"

  const [mobile, setMobile] = useState("91");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  // Registration form state
  const [regForm, setRegForm] = useState({
    name: "",
    email: "",
    businessName: "",
    address: "",
    additionalMobiles: "",
  });

  // UI controls
  const [cooldown, setCooldown] = useState(0);
  const [lockMsg, setLockMsg] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const cooldownTimerRef = useRef(null);
  const navigate = useNavigate();

  /* ===================== Utils ===================== */

  const normalizeMobile = (value) => {
    let val = value.replace(/\D/g, "");
    if (!val.startsWith("91")) val = "91" + val.replace(/^91/, "");
    return val.slice(0, 12);
  };

  const isValidMobile = (m) => /^91\d{10}$/.test(m);

  const clearCooldown = () => {
    if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
    setCooldown(0);
  };

  const startCooldown = (seconds) => {
    if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);

    setCooldown(seconds);

    cooldownTimerRef.current = setInterval(() => {
      setCooldown((c) => {
        if (c <= 1) {
          clearInterval(cooldownTimerRef.current);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
  };

  // Cleanup timer
  useEffect(() => {
    return () => {
      if (cooldownTimerRef.current) clearInterval(cooldownTimerRef.current);
    };
  }, []);

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  /* ===================== Handlers: LOGIN (OTP) ===================== */

  const handleSendOtp = async () => {
    if (!isValidMobile(mobile)) return alert("Enter 91 + 10 digit mobile.");
    if (isBlocked) return;

    setLoading(true);
    setLockMsg("");

    try {
      const res = await fetch(`${BACKEND_URL}/otp/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile }),
      });

      const data = await res.json();

      if (res.ok) {
        setOtpSent(true);
        setOtp("");
        startCooldown(60);
      }

      else if (res.status === 429) {
        const secs =
          parseInt(String(data?.error || "").match(/(\d+)s/)?.[1] || "30", 10);
        startCooldown(Math.max(20, secs));
        alert(data?.error || "Too many OTP attempts. Try again later.");
      }

      else if (res.status === 403) {
        setIsBlocked(true);
        setOtpSent(false);
        clearCooldown();
        setLockMsg(data?.error || "Your account is blocked by admin.");
      }

      else if (res.status === 423) {
        setIsBlocked(true);
        setOtpSent(false);
        clearCooldown();
        const msg =
          data?.error ||
          (data?.lockUntil
            ? `Try again after ${new Date(data.lockUntil).toLocaleString()}`
            : "Too many invalid OTP attempts.");
        setLockMsg(msg);
      }

      else {
        alert(data?.error || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!/^\d{6}$/.test(otp)) return alert("Enter 6 digit OTP");
    if (isBlocked) return;

    setLoading(true);
    setLockMsg("");

    try {
      const res = await fetch(`${BACKEND_URL}/otp/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile, otp }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("courtOwnerToken", data.token);
        localStorage.setItem("role", "court_owner");
        navigate("/courtowner/dashboard");
      }

      else if (res.status === 423) {
        setIsBlocked(true);
        clearCooldown();
        setLockMsg(data?.error || "Too many wrong OTP attempts. Try later.");
      }

      else if (res.status === 403) {
        setIsBlocked(true);
        clearCooldown();
        setLockMsg(data?.error || "Your account is blocked.");
      }

      else {
        alert(data?.error || "OTP verification failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const swapNumber = () => {
    setOtpSent(false);
    setOtp("");
    setIsBlocked(false);
    setLockMsg("");
    clearCooldown();
  };

  /* ===================== Handler: REGISTER ===================== */

  const handleRegister = async () => {
    if (!isValidMobile(mobile))
      return alert("Enter 91 + 10 digit mobile.");

    if (!regForm.name.trim()) return alert("Name is required");
    if (!regForm.businessName.trim()) return alert("Business Name is required");
    if (!regForm.email.trim()) return alert("Email is required");
    if (!isValidEmail(regForm.email.trim()))
      return alert("Enter valid email");

    const payload = {
      name: regForm.name.trim(),
      email: regForm.email.trim().toLowerCase(),
      businessName: regForm.businessName.trim(),
      address: regForm.address.trim(),
      mobile,
    };

    setLoading(true);
    try {
      const data = await courtOwnerApi.register(payload);

      if (data.success) {
        alert("Registered successfully. Login using OTP.");
        setRegForm({
          name: "",
          email: "",
          businessName: "",
          address: "",
          additionalMobiles: "",
        });
        setMode("login");
      } else {
        alert(data.error || "Registration failed");
      }
    } finally {
      setLoading(false);
    }
  };

  /* ===================== Render ===================== */

  const isLoginMode = mode === "login";

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgimage})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60" />
      <div className="relative bg-white p-8 rounded-xl shadow-2xl w-full max-w-md transition-all duration-300">
        <h2 className="text-3xl font-extrabold text-center mb-6 text-gray-800">
          Court Owner {isLoginMode ? "Login" : "Register"}
        </h2>

        {/* Tabs */}
        <div className="flex mb-6 border rounded-lg overflow-hidden">
          <button
            className={`flex-1 py-2 text-sm font-semibold ${
              isLoginMode
                ? "bg-indigo-600 text-white"
                : "bg-gray-100 text-gray-700"
            }`}
            onClick={() => {
              setMode("login");
              swapNumber();
            }}
          >
            Login with OTP
          </button>
          <button
            className={`flex-1 py-2 text-sm font-semibold ${
              !isLoginMode
                ? "bg-indigo-600 text-white"
                : "bg-gray-100 text-gray-700"
            }`}
            onClick={() => {
              setMode("register");
              swapNumber();
            }}
          >
            Register
          </button>
        </div>

        {/* Mobile Field */}
        <label className="block text-sm font-medium mb-1">
          Mobile Number (91XXXXXXXXXX)
        </label>

        <input
          type="text"
          value={mobile}
          onChange={(e) => setMobile(normalizeMobile(e.target.value))}
          disabled={isLoginMode && otpSent}
          className="w-full px-5 py-3 border rounded-lg mb-2"
        />

        {/* ===== LOGIN MODE ===== */}
        {isLoginMode && (
          <>
            {lockMsg ? (
              <p className="text-red-600 text-sm mb-2">{lockMsg}</p>
            ) : !otpSent ? (
              <p
                className={`text-sm mb-2 ${
                  isValidMobile(mobile) ? "text-green-600" : "text-gray-500"
                }`}
              >
                {isValidMobile(mobile)
                  ? "Mobile looks good."
                  : "Enter 91 + 10 digits."}
              </p>
            ) : null}

            {otpSent && (
              <>
                <label className="block text-sm font-medium mb-1 mt-2">
                  Enter 6-digit OTP
                </label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) =>
                    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                  disabled={isBlocked}
                  className="w-full px-5 py-3 border rounded-lg mb-2"
                />
              </>
            )}

            {/* Main OTP Button */}
            <button
              onClick={!otpSent ? handleSendOtp : handleVerifyOtp}
              disabled={
                loading ||
                isBlocked ||
                (!otpSent && (cooldown > 0 || !isValidMobile(mobile))) ||
                (otpSent && otp.length !== 6)
              }
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {loading
                ? "Processing..."
                : isBlocked
                ? "Blocked"
                : !otpSent
                ? cooldown > 0
                  ? `Send OTP (${cooldown}s)`
                  : "Send OTP"
                : "Verify OTP"}
            </button>

            {/* Resend + Change Number */}
            {otpSent && (
              <div className="mt-4 flex justify-between text-sm">
                <button className="underline" onClick={swapNumber}>
                  Change number
                </button>
                <button
                  disabled={cooldown > 0 || isBlocked}
                  onClick={handleSendOtp}
                  className={`underline ${
                    cooldown > 0 || isBlocked
                      ? "text-gray-400"
                      : "text-indigo-600"
                  }`}
                >
                  {cooldown > 0
                    ? `Resend in ${cooldown}s`
                    : "Resend OTP"}
                </button>
              </div>
            )}
          </>
        )}

        {/* ===== REGISTER MODE ===== */}
        {!isLoginMode && (
          <>
            <p className="text-sm text-gray-600 mb-3">
              Enter your details to register as a Court Owner.
            </p>

            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              type="text"
              value={regForm.name}
              onChange={(e) =>
                setRegForm((f) => ({ ...f, name: e.target.value }))
              }
              className="w-full px-5 py-3 border rounded-lg mb-3"
            />

            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              value={regForm.email}
              onChange={(e) =>
                setRegForm((f) => ({ ...f, email: e.target.value }))
              }
              className="w-full px-5 py-3 border rounded-lg mb-3"
            />

            <label className="block text-sm font-medium mb-1">
              Business Name
            </label>
            <input
              type="text"
              value={regForm.businessName}
              onChange={(e) =>
                setRegForm((f) => ({ ...f, businessName: e.target.value }))
              }
              className="w-full px-5 py-3 border rounded-lg mb-3"
            />

            <label className="block text-sm font-medium mb-1">Address</label>
            <textarea
              rows={3}
              value={regForm.address}
              onChange={(e) =>
                setRegForm((f) => ({ ...f, address: e.target.value }))
              }
              className="w-full px-5 py-3 border rounded-lg mb-3 resize-none"
            />

            <button
              onClick={handleRegister}
              disabled={loading}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
